// @flow
import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import type { StateType, DispatchType } from "../../../global/types/redux";
import LicenceList from "../../../account/components/licences/LicenceList";
import {
  buildLicenceItemJson,
  companyDialogMessages
} from "../../../account/components/companies/CompileCompanytoJson";
import { fetchLicenceList } from "../../actions/licenceAdminActions";
import { fetcCompanyList } from "../../actions/companyAdminActions";
import ChipInput from "../../../global/components/ChipInput";
import {
  StyledTextField,
  StyledSelect,
  LoadingProgress,
  SnackbarMessage,
  SingleSwitch,
  NoItem
} from "imagus-components";
import InfiniteCalendarSelect from "../../../global/components/InfiniteCalendarSelect";
import { propComparator } from "../../../global/functions/StringOperations";
import ExportLicenceToCsv from "./ExportLicenceToCsv";

import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";

type AdminLicencesStateType = {
  messageId: number,
  isFilterOpen: boolean,
  order: "createdDate" | "expiryDate" | "facebaseName" | "companyName",
  suquence: "asc" | "desc",
  companies: Array<string>,
  start_date: Date | null,
  end_date: Date | null,
  licence_type: string,
  status: string,
  host_id: string,
  snackOpen: boolean
};

class AdminLicences extends Component<*, AdminLicencesStateType> {
  constructor(props) {
    super(props);
    this.state = {
      messageId: 0,
      isFilterOpen: true,
      order: "createdDate",
      suquence: "asc",
      companies: [],
      start_date: null,
      end_date: null,
      licence_type: "ALL",
      status: "ALL",
      host_id: "",
      snackOpen: false
    };
  }

  componentDidMount() {
    this.props.actions.fetchLicenceList();
    if (this.props.companies === null) {
      this.props.actions.fetcCompanyList();
    }
  }

  switchModalStatus = (modalName: string): * => (status: boolean): * => {
    this.setState({ [modalName]: status });
  };

  openSnackbar = (messageId: number): * => {
    this.setState(
      { messageId: messageId },
      this.switchModalStatus("snackOpen")(true)
    );
  };

  handleTypeChange = (e: Event): * => {
    const name = e.target.name;
    const value = e.target.value;
    this.setState({ [name]: value });
  };

  syncChange = (name: string, value: Array<*>): * => {
    this.setState({ [name]: value });
  };

  handleTextChange = (e: Event & { currentTarget: HTMLInputElement }): * => {
    const name = e.currentTarget.name;
    const value = e.currentTarget.value;
    this.setState({
      [name]: value
    });
  };

  syncDateChange = (name: string, date: Date): * => {
    this.setState({ [name]: date });
  };

  handleSwitchChange = (event: Event): * => {
    const name = event.target.name;
    const value = event.target.checked;
    this.setState({
      [name]: value
    });
  };

  render(): * {
    const licences = this.props.licences && [...this.props.licences];

    let licenceNode = null;
    let companyList = [];
    let licenceArray = [];

    if (licences) {
      if (licences.length === 0) {
        licenceNode = <NoItem content="No Licence has created yet." />;
      } else {
        if (this.state.order === "createdDate") {
          licences.sort(
            propComparator("auditCreationDate", false, null, null, true)
          );
        } else if (this.state.order === "expiryDate") {
          licences.sort(propComparator("expiryDate", false, null, null, true));
        } else if (this.state.order === "facebaseName") {
          licences.sort(propComparator("facebase", true, "name"));
        } else if (this.state.order === "companyName") {
          licences.sort(propComparator("company", true, "name"));
        }

        if (this.state.suquence === "desc") {
          licences.reverse();
        }

        for (let i = 0; i < licences.length; i++) {
          let company = licences[i].company;
          let index = companyList.findIndex(x => x.value === company.id);
          if (index < 0) {
            companyList.push({ value: company.id, label: company.name });
          }
          licenceArray.push(buildLicenceItemJson(licences[i], true));
        }
        companyList.sort(propComparator("label", true));

        licenceNode = (
          <LicenceList
            licences={licenceArray}
            openSnackbar={this.openSnackbar}
            companyFilter={this.state.companies}
            dateStartFilter={this.state.start_date}
            dateEndFilter={this.state.end_date}
            licenceFilter={this.state.licence_type}
            statusFilter={this.state.status}
            hostidFilter={this.state.host_id}
            isAdmin
            displayCompany
            canEdit
          />
        );
      }
    }

    const OrderList = [
      { value: "createdDate", label: "Licence Created Date" },
      { value: "expiryDate", label: "Licence Expiry Date" },
      { value: "facebaseName", label: "Facebase Name" },
      { value: "companyName", label: "Company Name" }
    ];
    const SequenceList = [
      { value: "asc", label: "Ascending" },
      { value: "desc", label: "Descending" }
    ];

    const LicenceTypes = [
      { value: "ALL", label: "ALL" },
      { value: "LONGTERM", label: "Long Term Licence" },
      { value: "SHORTTERM", label: "Short Term Licence" },
      { value: "DEMO", label: "Demo Licence" },
      { value: "EVALUATION", label: "Evaluation Licence" }
    ];

    const StatusTypes = [
      { value: "ALL", label: "ALL" },
      { value: "EXPIRED", label: "Expired" },
      { value: "ACTIVE", label: "Active" }
    ];

    if (!licenceNode) {
      return (
        <div className="app-panel">
          <LoadingProgress />
        </div>
      );
    } else {
      return (
        <div className="app-panel">
          <SnackbarMessage
            open={this.state.snackOpen}
            handleModalStatus={this.switchModalStatus("snackOpen")}
            message={companyDialogMessages[this.state.messageId]}
          />
          <div className="app-panel-content">
            <Paper elevation={4} style={{ padding: "16px " }}>
              <SingleSwitch
                value={this.state.isFilterOpen}
                name="isFilterOpen"
                isRequired={false}
                label={["Show Criteria", "Hide Criteria"]}
                handleChange={this.handleSwitchChange}
              />
              <div style={{ float: "right" }}>
                <ExportLicenceToCsv
                  licences={licenceArray}
                  companies={this.props.companies}
                  companyFilter={this.state.companies}
                  dateStartFilter={this.state.start_date}
                  dateEndFilter={this.state.end_date}
                  licenceFilter={this.state.licence_type}
                  statusFilter={this.state.status}
                />
              </div>
              {this.state.isFilterOpen && (
                <Grid container spacing={24}>
                  <Grid item xs={12} md={6}>
                    <StyledSelect
                      value={this.state.order}
                      onChange={this.handleTypeChange}
                      name="order"
                      label="Order By"
                      isRequired={true}
                      menus={OrderList}
                      isStyled
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <StyledSelect
                      value={this.state.suquence}
                      onChange={this.handleTypeChange}
                      name="suquence"
                      label="Ascend | Descend"
                      isRequired={true}
                      menus={SequenceList}
                      isStyled
                    />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <InfiniteCalendarSelect
                      isRequired={false}
                      label="Select Start Date"
                      name="start_date"
                      value={this.state.start_date}
                      syncDateChange={this.syncDateChange}
                    />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <InfiniteCalendarSelect
                      isRequired={false}
                      label="Select End Date"
                      name="end_date"
                      value={this.state.end_date}
                      syncDateChange={this.syncDateChange}
                      isEndDate
                    />
                  </Grid>
                  <Grid item xs={12} md={6} className="top-margin-10">
                    <ChipInput
                      name="companies"
                      label="Select Companies"
                      isMultiple
                      placeholder="All Companies"
                      tags={companyList}
                      value={this.state.companies}
                      syncChange={this.syncChange}
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <StyledSelect
                      value={this.state.licence_type}
                      onChange={this.handleTypeChange}
                      name="licence_type"
                      label="Licence Type"
                      isRequired={true}
                      menus={LicenceTypes}
                      isStyled
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <StyledSelect
                      value={this.state.status}
                      onChange={this.handleTypeChange}
                      name="status"
                      label="Licence Status"
                      isRequired={true}
                      menus={StatusTypes}
                      isStyled
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <StyledTextField
                      isRequired={false}
                      label="Search HostId"
                      name="host_id"
                      value={this.state.host_id}
                      onChange={this.handleTextChange}
                      inpuType="text"
                    />
                  </Grid>
                </Grid>
              )}
            </Paper>
          </div>
          {licenceNode}
        </div>
      );
    }
  }
}

const mapStateToProps = (state: StateType): * => ({
  licences: state.v3admin.licence.licences,
  companies: state.v3admin.company.companies
});

const mapDispatchToProps = (dispatch: DispatchType): DispatchType => ({
  actions: bindActionCreators(
    {
      fetchLicenceList,
      fetcCompanyList
    },
    dispatch
  )
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AdminLicences);
